import { render } from "./UsuariosAdministracion.vue?vue&type=template&id=afc917c2"
import script from "./UsuariosAdministracion.vue?vue&type=script&lang=js"
export * from "./UsuariosAdministracion.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__